import React, { useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

const AmazonAuth = () => {
    useEffect(() => {
        // Vérifier si nous sommes dans un iframe
        if (window.self !== window.top) {
            // Nous sommes dans l'iframe
            const checkCookies = () => {
                const cookies = document.cookie;
                if (cookies) {
                    // Envoyer les cookies à la fenêtre parente
                    window.parent.postMessage({
                        type: 'AMAZON_COOKIES',
                        cookies: cookies
                    }, '*');
                }
            };

            // Vérifier les cookies toutes les secondes
            const interval = setInterval(checkCookies, 1000);

            // Nettoyer l'intervalle quand le composant est démonté
            return () => clearInterval(interval);
        }
    }, []);

    return (
        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            justifyContent: 'center',
            height: '100vh'
        }}>
            <Typography variant="h6" gutterBottom>
                Connexion à Amazon Seller Central
            </Typography>
            <CircularProgress />
        </Box>
    );
};

export default AmazonAuth; 